import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const GetPartnerCuratorsCountRequestSchema = z
  .object({
    platform: z.enum(['MUSINSA', '29CM']).describe('플랫폼'),
    brandId: z.string().describe('브랜드 ID'),
    nickname: z.string().optional(),
    gender: z.enum(['M', 'F']).optional(),
    ageRange: z.string().optional(),
    customerGender: z.enum(['M', 'F']).optional(),
    customerAgeRange: z.string().optional(),
    categoryCode: z.string().optional(),
    snsType: z.enum(['INSTAGRAM', 'YOUTUBE', 'TIKTOK', 'TWITTER', 'ETC']).optional(),
    likedBrand: z.boolean().optional(),
    likedByBrand: z.boolean().optional(),
    brandSoldHistory: z.boolean().optional(),
  })
  .describe('GetPartnerCuratorsCountRequestSchema');

export type GetPartnerCuratorsCountRequest = z.infer<typeof GetPartnerCuratorsCountRequestSchema>;

const GetPartnerCuratorsCountResponseDataSchema = z
  .object({
    count: z.number().int().optional(),
    totalCount: z.number().int().optional(),
  })
  .describe('GetPartnerCuratorsCountResponseDataSchema');

const GetPartnerCuratorsCountResponseSchema = createApiResponseSchema(
  GetPartnerCuratorsCountResponseDataSchema,
);

export type GetPartnerCuratorsCountResponse = z.infer<typeof GetPartnerCuratorsCountResponseSchema>;

export const getPartnerCuratorsCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetPartnerCuratorsCountRequestSchema),
    async (params: GetPartnerCuratorsCountRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetPartnerCuratorsCountResponse>(
          partnerApiPath.getCuratorsCount,
          params,
        ),
      ),
    validateApiResponse(GetPartnerCuratorsCountResponseSchema),
  ),
);
